import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';

import { InputDropDown } from '@sm360/widget-commons-forms';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, ModelYear } from '@sm360/widget-commons-vehicle';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import 'react-dropdown/style.css';

const { PaymentFrequencies, PaymentFrequencyService } = PurchaseMethods;

const CustomizePaymentFrequency = ({ purchaseMethods, onPaymentFrequencyClick, modelYear }) => {
    const frequencyOptions = PaymentFrequencyService.getPaymentFrequencyDropDownValues(LocaleService, purchaseMethods);
    const selectedFrequency = find(frequencyOptions, { value: purchaseMethods.getSelectedFinancePaymentFrequency() });
    const onChange = (paymentFrequency) => {
        onPaymentFrequencyClick(paymentFrequency, paymentFrequency.label);
        AnalyticsService.ga4Trigger(
            TAGS.PAYMENT_CALCULATOR_FREQUENCY(paymentFrequency.label, modelYear.model, modelYear.year)
        );
    };
    return (
        <div className="customize-payment-frequency">
            <InputDropDown
                name="paymentFrequencies"
                options={frequencyOptions}
                value={selectedFrequency ? selectedFrequency.value : PaymentFrequencies.MONTHLY}
                valueChange={onChange}
                classNames={['sr-paymentCalculator-dropdown']}
            />
        </div>
    );
};

CustomizePaymentFrequency.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
    onPaymentFrequencyClick: PropTypes.func.isRequired,
};

CustomizePaymentFrequency.displayName = 'CustomizePaymentFrequency';

export default CustomizePaymentFrequency;
